import React, { memo } from 'react';
import { View, Image, StyleSheet } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Space } from '@redlink/components/atoms';

export const AuthPageContainerRootContainer = memo(({ children }) => {
  const { styles } = useStyle();
  return (
    <View style={styles.container}>
      <View style={[styles.mainContainer]}>
        {children}
        <Space />
        <View style={styles.previewContainer}>
          <Image
            style={styles.image}
            resizeMode="center"
            source={require('@redlink/assets/images/login_image_1.png')}
          />
        </View>
      </View>
    </View>
  );
});

const useStyle = createUseStyle(({ colors, size }) => ({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  mainContainer: {
    width: '80%',
    maxWidth: 850,
    height: '80%',
    backgroundColor: colors.red1,
    borderRadius: 20,
    padding: 8,
    flexDirection: 'row',
  },
  previewContainer: {
    flex: 1,
    justifyContent: 'center',
  },
  image: {
    ...StyleSheet.absoluteFillObject,
    margin: 50,
  },
}));
